import React from 'react';
import moment from 'moment';
import _ from 'lodash';

const headerStyle = () => {
    return { borderColor: '#a81933' };
};

const columnStyle = () => {
    return { overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' };
};

const dateFormatter = (value) => {
    return (_.isEmpty(value)) ? null : moment(value).format('MM/DD/YYYY hh:mm A');
};

const mediaFormatter = (value) => {
    return <a href={value} target="_blank" rel="noopener noreferrer">{value}</a>;
};

export const columns = [
    {
        dataField: 'toPhoneNumber',
        text: 'Phone Number',
        sort: true,
        headerStyle: headerStyle,
        style: columnStyle
    },
    {
        dataField: 'queuedAt',
        text: 'Queued At',
        sort: true,
        headerStyle: headerStyle,
        style: columnStyle,
        formatter: (_cell, row) => dateFormatter(row.queuedAt)
    },
    {
        dataField: 'message',
        text: 'Message',
        sort: true,
        headerStyle: headerStyle,
        style: columnStyle
    },
    {
        dataField: 'mediaUrl',
        text: 'Media Url',
        sort: true,
        headerStyle: headerStyle,
        style: columnStyle,
        formatter: (_cell, row) => mediaFormatter(row.mediaUrl)
    }
];
    
export const sorting = [{
    dataField: 'toPhoneNumber',
    order: 'desc'
}];